import React from 'react';
import PropTypes from 'prop-types';
import './DemoModeHeaderBody.scss';
import runningGirl from '../../../../../runningGirl.svg';

const DemoModeHeaderBody = ({
    demoControls,
    demoTourMap,
    isGuidedTourOn,
    hasTourStarted,
    setHasDemoTypeTransitionEnded,
    hasError,
}) => {
    const inTourClassName = isGuidedTourOn ? 'in-tour' : '';
    const isProbeDetailsOpen =
        window.location.href.includes('resultId=') && isGuidedTourOn ? 'probe-details-open' : '';
    const handleOnTransitionEnd = e => {
        e.preventDefault();

        if (!hasTourStarted) {
            setHasDemoTypeTransitionEnded(true);
        }
    };
    return (
        <div className={`${inTourClassName}`} id="demo-mode-header-body">
            {demoControls}
            <div
                className={`flex-row ${inTourClassName} ${isProbeDetailsOpen}  ${
                    hasError ? ' has-error' : ''
                }`}
                id="demo-mode-map-container"
                onTransitionEnd={handleOnTransitionEnd}
            >
                {demoTourMap}
                <div className="demo-mode-map-image" />
                <div className="tour-image-container">
                    <img src={runningGirl} alt="running-girl" className="running-girl-svg" />
                    <a
                        href="https://pd.amplify.com/resource/mclass/classroom-reporting/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="more-tutorials btn btn-oval"
                    >
                        More Tutorials
                    </a>
                </div>
            </div>
        </div>
    );
};

DemoModeHeaderBody.defaultProps = {
    isGuidedTourOn: false,
    hasTourStarted: false,
    hasError: false,
    setHasDemoTypeTransitionEnded: () => {},
    demoTourMap: <></>,
    demoControls: <></>,
};
DemoModeHeaderBody.propTypes = {
    isGuidedTourOn: PropTypes.bool,
    hasTourStarted: PropTypes.bool,
    setHasDemoTypeTransitionEnded: PropTypes.func,
    demoTourMap: PropTypes.element,
    demoControls: PropTypes.element,
    hasError: PropTypes.bool,
};

export default DemoModeHeaderBody;
